export default __webpack_public_path__ + "static/media/GR001393.21b16ad9.JPG";